import { Pipe, PipeTransform } from '@angular/core';

type RateType = ('STAR_FILLED' | 'STAR_HALF' | 'STAR_EMPTY')[];

@Pipe({
  name: 'meanArray',
  standalone: true,
})
export class MeanArrayPipe implements PipeTransform {
  transform(mean: number): RateType {
    const rate: RateType = [];
    for (let i = 0; i < 5; i++) {
      if (mean >= 1) {
        rate.push('STAR_FILLED');
      } else if (mean >= 0.5) {
        rate.push('STAR_HALF');
      } else {
        rate.push('STAR_EMPTY');
      }
      mean--;
    }
    return rate;
  }
}
